import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import ProductFillablePdfField from '../productFillablePdfField/Model.ProductFillablePdfField';
import ProductSignatureField from '../productSignatureField/Model.ProductSignatureField';
import productDocumentDeleteApi from './delete/Api.ProductDocument.Delete';
import productDocumentFindApi from './find/Api.ProductDocument.Find';
import productDocumentSaveApi from './save/Api.ProductDocument.Save';
import ProductDealerDocument from 'models/dealerManagement/productDealerDocument/Model.ProductDealerDocument';
import ProductDealerGroupDocument from 'models/dealerManagement/productDealerGroupDocument/Model.ProductDealerGroupDocument';
import { Language } from 'assets/locales/Locale';

export default class ProductDocument
  extends Model<Model.IProductDocument>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductDocument>
{
  id: number;
  productId: number;
  orderNumber: number;
  mediaFileId: number;
  mediaFile: MediaFile;
  formFile?: File;
  documentCategory: Model.Enum.EngineType;
  fillablePdfFields: Array<ProductFillablePdfField>;
  signatureFields: Array<ProductSignatureField>;
  productDealerDocument: Array<ProductDealerDocument>;
  productDealerGroupDocuments: Array<ProductDealerGroupDocument>;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data: Partial<Model.IProductDocument> | Utils.FormData<Model.IProductDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        fillablePdfFields: [ProductFillablePdfField],
        signatureFields: [ProductSignatureField],
        productDealerDocument: [ProductDealerDocument],
        productDealerGroupDocuments: [ProductDealerGroupDocument],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id.toString(),
    };
  }
  static async find(params: Api.Core.ProductDocument.Find.IRequest) {
    const { payload, ...rest } = await productDocumentFindApi(params);
    return {
      ...rest,
      payload: payload ? new ProductDocument(payload) : null,
    };
  }
  async save() {
    return await productDocumentSaveApi(this);
  }
  async delete() {
    return await productDocumentDeleteApi({ productId: this.productId, documentId: this.id });
  }
}
